<template>
  <img
    :src="item.url"
    class="icon"
    :style="{
      width: item.size || '20px',
      aspectRatio: item.aspectRatio || '1 / 1'
    }"
  />
</template>

<script setup>
defineProps({
  item: Object
})
</script>

<style scoped>
.icon {
  display: inline-block;
  vertical-align: middle;
  object-fit: contain;
  margin-right: 4px;
}
</style>
